<script>
  import { createEventDispatcher } from "svelte";
  export let show = false;
  export let modalContentClass = "";
  const dispatch = createEventDispatcher();

  function keydown(event) {
    if (event.key === "Escape") {
      dispatch("close");
    }
  }
</script>

<svelte:window on:keydown={keydown} />

{#if show}
  <div class="modal active" on:click|self={() => dispatch("close")}>
    <div class="modal-content {modalContentClass}">
      <div class="modal-header">
        <slot name="header"></slot>
        <button class="close-btn" on:click={() => dispatch("close")}>×</button>
      </div>
      <slot name="body"></slot>
    </div>
  </div>
{/if}

<style>
  .close-btn {
    background: none;
    border: none;
    color: var(--text-color);
    cursor: pointer;
    opacity: 0.7;
  }
  .close-btn:hover {
    opacity: 1;
  }
</style>
